module.exports = __webpack_public_path__ + "static/media/truck9b.93f0a089.svg";